import React from 'react';

import { FullPageCard } from '@global-components/FullPageCard';

import { useScreenBreakpoints } from '@hooks/Layout/useScreenBreakpoints';

import { LoansStepper } from '../../../features/loans/components/Application/Stepper/LoansStepper';
import { useLoanApplicationSelector } from '../../../features/loans/xstate/LoanApplication.context';

export const mergeMeta = (meta: Record<string, object>): Record<string, any> =>
  Object.keys(meta).reduce((acc, key) => {
    const value = meta[key];
    Object.assign(acc, value);
    return acc;
  }, {});

type Props = {
  handleExit: () => void;
};

const LoanApplication: React.FC<Props> = () => {
  const { isLargeScreen } = useScreenBreakpoints();
  const ActiveStepComponent = useLoanApplicationSelector((state) => mergeMeta(state.meta)?.Component);

  // TODO: avo

  // TODO: convert FullPageCard to use Aviary components
  return (
    <FullPageCard
      id='loan-application'
      headerChildren={
        isLargeScreen && (
          <div className='w-full pr-12 md:w-1/3'>
            <LoansStepper />
          </div>
        )
      }
    >
      {ActiveStepComponent && <ActiveStepComponent />}
    </FullPageCard>
  );
};

LoanApplication.displayName = 'Loan Application';

export default LoanApplication;
